import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../admin.service';
import { AdminAddPromotionalNotificationComponent } from '../admin-add-promotional-notification/admin-add-promotional-notification.component';

@Component({
  selector: 'app-admin-promotional-notification',
  templateUrl: './admin-promotional-notification.component.html',
  styleUrls: ['./admin-promotional-notification.component.css']
})
export class AdminPromotionalNotificationComponent implements OnInit {

  notifications: any[] = [];
  token: string | null = null;
  selectedFilter: 'all' | 'sent' | 'draft' = 'all';
  
  fetch_page: number = 1;
  currentPage: number = 1;
  startPage: number = 1;
  last_page: number = 1;
  perPage: number = 10;
  paginationNotifications: boolean = true;
  loading: boolean = false;

  get filteredNotifications(): any[] {
    if (this.selectedFilter === 'sent') return this.notifications.filter(n => n.is_active);
    if (this.selectedFilter === 'draft') return this.notifications.filter(n => !n.is_active);
    return this.notifications;
  }

  setFilter(filter: 'all' | 'sent' | 'draft') {
    this.selectedFilter = filter;
  }

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem('adminToken');
    this.fetchNotifications();
  }

  fetchNotifications() {
    this.loading = true;
    this.adminService.getPromotionalPushNotifications(this.token, this.startPage, this.perPage).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status === 200) {
          if (res.body?.data && res.body?.meta) {
            this.notifications = res.body.data;
            this.last_page = res.body.meta.lastPage || 1;
            this.paginationNotifications = true;
          } else {
            this.notifications = res.body?.data || res.body || [];
            this.last_page = 1;
            this.paginationNotifications = false;
          }
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error fetching notifications:', err);
        this.snackBar.open('Failed to load notifications.', 'Close', { duration: 4000 });
      }
    });
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1);
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1;
    } else if (page_status == "last") {
      newPage = this.last_page || 1;
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    this.fetchNotifications();
  }

  openAddDialog(notif: any = null) {
    const dialogRef = this.dialog.open(AdminAddPromotionalNotificationComponent, {
      width: '40vw',
      disableClose: true,
      data: notif,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchNotifications();
      }
    });
  }

  sendNotification(notif: any) {
    this.adminService.triggerPromotionalPushNotification(notif._id || notif.id, this.token).subscribe({
      next: (res: any) => {
        const msg = res.body?.message || 'Notification triggered successfully!';
        this.snackBar.open(msg, 'OK', { duration: 4000 });
        this.fetchNotifications();
      },
      error: (err) => {
        console.error('Error triggering notification:', err);
        const errMsg = err?.error?.message || 'Failed to trigger notification.';
        this.snackBar.open(errMsg, 'Close', { duration: 5000 });
      }
    });
  }

  deleteNotification(notif: any) {
    if (confirm('Are you sure you want to delete this notification?')) {
      this.adminService.deletePromotionalPushNotification(notif._id || notif.id, this.token).subscribe({
        next: (res: any) => {
          const msg = res.body?.message || 'Notification deleted successfully.';
          this.snackBar.open(msg, 'OK', { duration: 3000 });
          this.fetchNotifications();
        },
        error: (err) => {
          console.error('Error deleting notification:', err);
          const errMsg = err?.error?.message || 'Failed to delete notification.';
          this.snackBar.open(errMsg, 'Close', { duration: 5000 });
        }
      });
    }
  }
}
